// resources
import * as BBApi from '.';
import moment from 'moment';
const rootUrl: string = BBApi.host + '/new-year';

export async function totalUserCount(): Promise<number> {
  const url: URL = new URL(rootUrl + '/users');
  
  url.searchParams.append('dateFrom', '2021-01-01');
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { userCount } = await response.json();
	return userCount;
}

export async function totalUserCount24h(): Promise<number> {
  const url: URL = new URL(rootUrl + '/users');
  const dateFrom = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')

	url.searchParams.append('dateFrom', dateFrom);
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { userCount } = await response.json();
	return userCount;
}

export async function totalPostCount(): Promise<number> {
  const url: URL = new URL(rootUrl + '/posts');
  
  url.searchParams.append('dateFrom', '2021-01-01');
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { postCount } = await response.json();
	return postCount;
}

export async function totalPostCount24h(): Promise<number> {
  const url: URL = new URL(rootUrl + '/posts');
  const dateFrom = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')

	url.searchParams.append('dateFrom', dateFrom);
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { postCount } = await response.json();
	return postCount;
}

export type PostLocation = { name: string, location: string }
export async function postLocations(): Promise<any> {
  const url: URL = new URL(rootUrl + '/posts/locations');
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const postLocations = await response.json();
	return postLocations;
}

export async function totalMessageCount(): Promise<number> {
	const url: URL = new URL(rootUrl + '/messages');
	url.searchParams.append('dateFrom', '2021-01-01');
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { messageCount } = await response.json();
	return messageCount;
}

export async function totalMessageCount24h(): Promise<number> {
  const url: URL = new URL(rootUrl + '/messages');
  const dateFrom = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')

	url.searchParams.append('dateFrom', dateFrom);
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { messageCount } = await response.json();
	return messageCount;
}

export async function totalConversationCount(): Promise<number> {
	const url: URL = new URL(rootUrl + '/conversations');
	url.searchParams.append('dateFrom', '2021-01-01');
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { conversationCount } = await response.json();
	return conversationCount;
}

export async function totalConversationCount24h(): Promise<number> {
  const url: URL = new URL(rootUrl + '/conversations');
  const dateFrom = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')

	url.searchParams.append('dateFrom', dateFrom);
	
	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const { conversationCount } = await response.json();
	return conversationCount;
}
